import React from "react";
import { Link } from "react-router-dom";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import CEOMessage from "../components/sections/CEOMessage";
import Staff from "../components/sections/Staff";
import WhyChooseUs from "../components/sections/WhyChooseUs";

function AboutPage() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                About Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    About
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="assets/img/about-img.jpg"
                  alt="About All World Recruiting"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to{" "}
                <span className="text-primary">
                  All World Recruiting & Overseas Employment Agency
                </span>
              </h1>
              <p className="mb-4">
                All World Recruiting & Overseas Employment Agency is dedicated
                to supplying qualified and dependable manpower across
                international markets, especially in Gulf countries. With a deep
                understanding of global hiring standards and workforce
                requirements, we help individuals build successful careers
                abroad while assisting companies in finding the right talent.
              </p>
              <p className="mb-4">
                We operate with transparency, professionalism, and commitment,
                ensuring every recruitment process is smooth and reliable for
                both employers and candidates.
              </p>
              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Overseas employment opportunities
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Skilled and unskilled manpower supply
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Strong network in Gulf region hiring
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    24/7 Professional Support
                  </p>
                </div>
              </div>
              <Link className="btn btn-primary py-3 px-5 mt-2" to="/contact">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
      <CEOMessage />
      <WhyChooseUs />
      <Staff />
      <Testimonials />
      <FAQ />
    </div>
  );
}

export default AboutPage;
